// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import React, { Suspense } from 'react';

import { Loader } from '../../../web-utils/src/UI/Component/React/V1/Loader/Loader';

import styles from './styles.module.css';

// Suspense wrapper HOC
export const withSuspense = Component => (
  <Suspense
    fallback={
      <div className={styles.container}>
        <Loader small={true} />
      </div>
    }
  >
    <Component />
  </Suspense>
);
